import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { MapPin, Phone } from 'lucide-react'
import { cn } from '@/lib/utils'
import { ButtonLink } from '@/components/generals/button'
import { OpeningStatusLine } from '@/components/generals/opening-status'

import { directions, garage } from '@/constants/garage'

// Barre d'appel mobile : apparaît une fois les boutons du hero sortis de l'écran.
// La place qu'elle occupe est réservée en bas du pied de page, elle ne masque rien.
export const MobileCallBar: FC = (): ReactNode => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const target = document.getElementById('hero-actions')

        if (!target || typeof IntersectionObserver === 'undefined') {
            setVisible(true)

            return
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (!entry) return

            setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0)
        })

        observer.observe(target)

        return () => observer.disconnect()
    }, [])

    return (
        <div
            aria-hidden={!visible}
            inert={!visible}
            className={cn(
                'fixed inset-x-0 bottom-0 z-30 border-t border-border bg-background lg:hidden',
                'transition-transform duration-300 ease-out-soft',
                visible ? 'translate-y-0' : 'translate-y-full'
            )}
        >
            <div className='flex items-center gap-2 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3'>
                <OpeningStatusLine className='min-w-0 flex-1 text-[0.8125rem] leading-snug' />

                <ButtonLink
                    href={directions.google}
                    target='_blank'
                    rel='noopener noreferrer'
                    variant='secondary'
                    size='icon'
                    aria-label='Itinéraire vers l’atelier, ouvre Google Maps'
                >
                    <MapPin aria-hidden='true' className='size-5' />
                </ButtonLink>

                <ButtonLink href={garage.phone.href} className='px-4'>
                    <Phone aria-hidden='true' className='size-5' />
                    Appeler
                </ButtonLink>
            </div>
        </div>
    )
}
